var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRemoveArtist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91667 17.4167L4.57572 17.4167C3.28791 17.4167 2.26359 16.79 1.34388 15.9138C-0.538863 14.1201 2.55234 12.6867 3.73131 11.9847C5.73066 10.7942 8.11875 10.4646 10.3333 10.996",
    stroke: "#FFBDBD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.833 4.5C12.833 6.57107 11.1541 8.25 9.08301 8.25C7.01194 8.25 5.33301 6.57107 5.33301 4.5C5.33301 2.42893 7.01194 0.75 9.08301 0.75C11.1541 0.75 12.833 2.42893 12.833 4.5Z",
    stroke: "#FFBDBD",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.416 17.417L14.916 14.917M14.916 14.917L17.416 12.417M14.916 14.917L12.416 12.417M14.916 14.917L17.416 17.417",
    stroke: "#FFBDBD",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemoveArtist);
export default __webpack_public_path__ + "static/media/icon-remove-artist.ddeb14856b673e0ebc7fcebc975e58b0.svg";
export { ForwardRef as ReactComponent };